import { render } from "./Inscription.vue?vue&type=template&id=8f062238&scoped=true"
import script from "./Inscription.vue?vue&type=script&lang=js"
export * from "./Inscription.vue?vue&type=script&lang=js"

import "./Inscription.vue?vue&type=style&index=0&id=8f062238&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f062238"]])

export default __exports__